<template>
  <a-drawer
    title="Mass Upload Products"
    :width="480"
    placement="right"
    :visible="visible"
    @close="onClose(false)"
  >
    <a-spin :spinning="fetching">
      <div class="mb-3">
        <h3>
          Import
          {{ isExclusion ? "Excluded" : "Included" }}
          Products
        </h3>
      </div>

      <base-alert v-if="errMsgs.length" type="danger">
        <b>The following errors occurred:</b>
        <li v-for="error in errMsgs" :key="error">{{ error }}</li>
      </base-alert>

      <a-upload-dragger
        :before-upload="beforeUpload"
        :remove="handleRemove"
        :fileList="fileList"
        :multiple="false"
        accept=".csv, .CSV"
      >
        <span class="fa fa-file-import" style="font-size: 20pt" />
        <p class="ant-upload-text">Click or drag file to upload</p>
        <p class="ant-upload-hint">
          File must contain header: <b>stock_no</b>
        </p>
        <p class="ant-upload-hint">
          Products will be processed after saving the discount.
        </p>
      </a-upload-dragger>

      <br />

      <a-collapse>
        <a-collapse-panel header="Downloadable Template" key="1">
          <a-list bordered>
            <a-list-item>
              <a-list-item-meta description="Contains required CSV format">
                <a @click.prevent="downloadTemplate" slot="title">
                  Download Discount {{ isExclusion ? "Excluded" : "Included" }} Products Template
                </a>
              </a-list-item-meta>
              <div>
                <a @click.prevent="downloadTemplate">
                  <span class="fa fa-file-download" />
                </a>
              </div>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
    </a-spin>

    <div class="drawer-footer">
      <button
        class="btn btn-sm btn-primary float-right"
        style="width: 30%"
        @click.prevent="uploadProducts"
      >
        Upload
      </button>
      <button
        class="btn btn-sm btn-secondary float-right"
        style="width: 30%; margin-right: 5%"
        @click.prevent="onClose(false)"
      >
        Cancel
      </button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState } from "vuex";
import secureStorage from "../../../controllers/secureStorage.js";

export default {
  props: {
    discountId: { type: Number, required: true },
    visible: { type: Boolean, default: false },
    onClose: { type: Function, required: true },
    // addProducts: { type: Function, required: true },
    // includeItemOption: { type: Number, required: true },
    // isExclusion: { type: Boolean, default: false },
    onFileSelected: { type: Function, required: true },
  },
  data() {
    return {
      fetching: false,
      errMsgs: [],
      fileList: [],
      parsedProducts: [],
    };
  },
  computed: {
    ...mapState(["endPoint"]),
  },
  methods: {
    downloadTemplate() {
      const csvContent = "stock_no\nABC\nDE-FGH\n";
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute(
        "download",
        `Discount_${this.isExclusion ? "Excluded" : "Included"}_Products_Template.csv`
      );
      document.body.appendChild(link);
      link.click();
    },

    beforeUpload(file) {
      this.errMsgs = [];
      this.fetching = true;

      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split(/[\r\n]+/g);
        const headers = lines[0].trim().toLowerCase();

        if (headers !== "stock_no") {
          this.errMsgs.push("Invalid CSV header. Expected: stock_no");
        }

        const stockNos = lines
          .slice(1)
          .map((l) => l.trim())
          .filter(Boolean);

        if (stockNos.length === 0) {
          this.errMsgs.push("No product stock_no found in CSV file.");
        }

        // detect duplicates
        const dupes = stockNos.filter((v, i, a) => a.indexOf(v) !== i && v !== "");
        if (dupes.length > 0) {
          this.errMsgs.push(`Duplicate stock_no detected: ${dupes.join(", ")}`);
        }

        if (this.errMsgs.length === 0) {
          this.fileList = [file];
          this.parsedProducts = stockNos.map((sn) => ({ stock_no: sn }));
        } else {
          this.fileList = [];
          this.parsedProducts = [];
        }

        this.fetching = false;
      };

      reader.readAsText(file);
      return false; // prevent auto upload
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) this.fileList.splice(index, 1);
    },

    uploadProducts() {
      if (this.fileList.length === 0 || this.parsedProducts.length === 0) {
        this.$notification["error"]({
          message: "No CSV selected",
          description: "Please upload a valid CSV file before proceeding.",
        });
        return;
      }

      if (this.onFileSelected && typeof this.onFileSelected === "function") {
        this.onFileSelected(this.fileList[0]);
      }

      this.$notification["success"]({
        message: "File parsed successfully",
        description: `${this.parsedProducts.length} products ready for ${
          this.isExclusion ? "exclusion" : "inclusion"
        }.`,
      });

      this.onClose(false);
    },
  },
};
</script>

<style scoped>
.drawer-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: -webkit-fill-available;
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
